import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { preloadChunkForPath } from './lib/routeChunkPreloads';
import { bootstrapDashboardPrefsFromStorage } from './lib/dashboardPrefsBootstrap';

if (typeof window !== 'undefined') {
  bootstrapDashboardPrefsFromStorage();
  preloadChunkForPath(window.location.pathname);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
